import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { errorMessage } from "../../lib/errorMessage";
import { Button } from "../ui/button";
import {
  ResponsiveDropdownMenu as DropdownMenu, ResponsiveDropdownMenuContent as DropdownMenuContent, ResponsiveDropdownMenuItem as DropdownMenuItem,
  ResponsiveDropdownMenuTrigger as DropdownMenuTrigger,
} from "../ui/responsive-dropdown-menu";

const CHOICES = [["nodes", "Les éléments (CSV)"], ["relations", "Les relations avec leur preuve (CSV)"]];

// Controlled export (lot CRM-5): names, paths and line numbers of the version being read — never code, never a value. Needs architecture:export.
export default function ExportMenu({ snapshot, module = "" }) {
  const [busy, setBusy] = useState(false);
  const download = async (format) => {
    setBusy(true);
    try {
      const params = { format, ...(snapshot ? { snapshot } : {}), ...(module ? { module } : {}) };
      const { data } = await api.get("/architecture/export.csv", { params, responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `jamora-cartographie-${format}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      toast.error(errorMessage(e, "Impossible de télécharger l'export. Réessayez dans quelques instants."));
    } finally {
      setBusy(false);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={busy} data-testid="arch-export"><Download size={16} className="mr-1.5" aria-hidden />Exporter</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent title="Exporter" align="end">
        {CHOICES.map(([id, label]) => <DropdownMenuItem key={id} onClick={() => download(id)} data-testid={`arch-export-${id}`}>{label}</DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
